import { render, staticRenderFns } from "./AdminHomepage.vue?vue&type=template&id=6921b522&lang=pug"
import script from "./AdminHomepage.vue?vue&type=script&lang=ts"
export * from "./AdminHomepage.vue?vue&type=script&lang=ts"
import style0 from "./AdminHomepage.vue?vue&type=style&index=0&id=6921b522&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports